export const authEndpoint = "https://accounts.spotify.com/authorize";
const redirectUri = "https:%2F%2Fspotify-clone-7e47e.web.app%2F" ;  
const clientId = "89be3ced44db4a52861f96a44d61c595";

//permission for the user
const scopes = [
  "user-read-currently-playing",
  "user-read-recently-played",
  "user-read-playback-state",
  "user-top-read",
  "user-modify-playback-state",
];

export const getTokenFromUrl = () => {
  return window.location.hash
    .substring(1)
    .split("&")             //  #access_token=BQCagCPrIYInxCknJ&token_type=Bearer&expires_in=360    
    .reduce((initial, item) => {
      let parts = item.split("=");
      initial[parts[0]] = decodeURIComponent(parts[1]);
      return initial;
    }, {});
};

export const loginUrl = `${authEndpoint}?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scopes.join(
  "%20"
)}&response_type=token&show_dialog=true`;

